import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getExistingTestScripts = async (id: string) => {
	const resp = await apiWrapper.get<any, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-steps/${id}`,
	);
	return resp;
};
